import _extends from "@babel/runtime/helpers/esm/extends";
import { ACTIONS, ENTITIES, VEHICLE_ITEMS } from '../constants';
import { buildVehicleFilterUrl, buildCurrentUrlData } from '../helpers/cardanDataHelpers';
var CardanDataEvents = function CardanDataEvents(state, dispatch) {
  var handleBrandChange = function handleBrandChange(value) {
    var _state$data;
    var brandEntity = ENTITIES.BRANDS;
    var brands = state == null ? void 0 : (_state$data = state.data) == null ? void 0 : _state$data[brandEntity];
    var selectedBrandObj = brands == null ? void 0 : brands.find(function (brand) {
      return String(brand == null ? void 0 : brand.name) === String(value);
    });
    dispatch({
      payload: {
        id: value,
        urlLogo: (selectedBrandObj == null ? void 0 : selectedBrandObj.urlLogo) || null
      },
      type: ACTIONS.CHANGE_BRAND
    });
  };
  var handleFormFieldChange = function handleFormFieldChange(field, value) {
    switch (field) {
      case 'brand':
        handleBrandChange(value);
        break;
      case 'model':
        dispatch({
          payload: value,
          type: ACTIONS.CHANGE_MODEL
        });
        break;
      case 'year':
        dispatch({
          payload: value,
          type: ACTIONS.CHANGE_YEAR
        });
        break;
      case 'version':
        dispatch({
          payload: value,
          type: ACTIONS.CHANGE_VERSION
        });
        break;
      default:
        break;
    }
  };
  var handleFormReset = function handleFormReset() {
    dispatch({
      type: ACTIONS.RESET_ALL
    });
  };
  var handleFormSearch = function handleFormSearch() {
    var _state$selected;
    if (!((_state$selected = state.selected) == null ? void 0 : _state$selected.version)) {
      return;
    }
    var currentUrl = buildVehicleFilterUrl(_extends({
      selected: state.selected,
      vehicleItems: VEHICLE_ITEMS
    }, buildCurrentUrlData()));
    var vehicleDetails = "".concat(state.selected.brand, " ").concat(state.selected.model, " ").concat(state.selected.year, " ").concat(state.selected.version);
    dispatch({
      payload: vehicleDetails,
      type: ACTIONS.SET_VEHICLE_DETAILS
    });
    dispatch({
      payload: currentUrl,
      type: ACTIONS.SAVE_SEARCH_URL
    });
    dispatch({
      payload: true,
      type: ACTIONS.SET_SHOW_SUMMARY
    });
  };
  var handleShowSummary = function handleShowSummary(value) {
    dispatch({
      payload: value,
      type: ACTIONS.SET_SHOW_SUMMARY
    });
  };
  return {
    handleFormFieldChange: handleFormFieldChange,
    handleFormReset: handleFormReset,
    handleFormSearch: handleFormSearch,
    handleShowSummary: handleShowSummary
  };
};
export default CardanDataEvents;